import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancelPage() {
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 text-center" data-testid="billing-cancel">
      <div className="grid place-items-center mb-4">
        <div className="w-14 h-14 grid place-items-center bg-neutral-100 border border-neutral-200">
          <XCircle size={28} className="text-neutral-500" />
        </div>
      </div>
      <div className="text-xs font-mono-tech tracking-[0.25em] text-neutral-500 mb-2">CHECKOUT · CANCELLED</div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold leading-none mb-3">No worries.</h1>
      <p className="text-sm text-neutral-600 mb-6">
        You weren't charged. You can pick a plan whenever you're ready.
      </p>
      <div className="flex items-center justify-center gap-2">
        <Link to="/pricing" data-testid="billing-cancel-pricing" className="px-5 h-11 inline-flex items-center bg-[#FF5100] hover:bg-[#E64A00] text-white text-xs font-bold uppercase tracking-wider">
          See plans
        </Link>
        <Link to="/" className="px-5 h-11 inline-flex items-center border border-neutral-200 hover:border-neutral-300 text-xs font-bold uppercase tracking-wider">
          Home
        </Link>
      </div>
    </div>
  );
}
